import { FormGroup } from '@angular/forms';
import { RessourcesForm, RessourcesModel } from '../../ressources/models/ressources.model';
import { SitProForm, SitProModel } from '../../sitpro/models/sitpro.model';
import { TypePersonneEnum } from '../enum/type-personne.enum';

/**
 * Données associées aux personnes
 */
export class PersonneModel {

    public typePersonne : TypePersonneEnum;
    public ressources : RessourcesModel;
    public sitPro : SitProModel;
    
    setRessources(val : RessourcesModel) {
        this.ressources = val;
    }
    getRessources(): RessourcesModel {
        return this.ressources;
    }

    setTypePersonne(val : TypePersonneEnum) {
        this.typePersonne = val;
    }
    getTypePersonne(): TypePersonneEnum {
        return this.typePersonne;
    }

    setSitPro(val : SitProModel) : void {
        this.sitPro = val;
    }
    getSitPro() : SitProModel {
        return this.sitPro;
    }

}

export class PersonneForm {
    ressources? : FormGroup<RessourcesForm>;
    sitro?:FormGroup<SitProForm>;
}
